import { OperatorTypeDetails, OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import FacetType from '../../../utility/types/facetType';
import { facetTypeDetails } from '../../../utility/types/facetTypeDetails';
import { store } from '../../../redux/store';

class ChannelAlertCountFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = FacetType.CHANNEL_ALERT_COUNT;
    this.displayName = 'Channel Alert Count';
    this.description = 'include...';
    this.storeState = store.getState();
  }

  getAlertListLength() {
    const alerts = this.storeState.alertList.alertList;
    if (alerts) {
      return alerts.length;
    } return 0;
  }

  // eslint-disable-next-line class-methods-use-this
  getOperatorDescription(operatorType) {
    const operatorDescriptions = {
      [OperatorTypes.GREATER_THAN]: OperatorTypeDetails[OperatorTypes.GREATER_THAN].label,
      [OperatorTypes.LESS_THAN]: OperatorTypeDetails[OperatorTypes.LESS_THAN].label,
      [OperatorTypes.EQUAL_TO_VALUE]: 'is equal to',
    };
    return operatorDescriptions[operatorType] || '';
  }

  getOperatorSelectOptions() {
    const facet = facetTypeDetails[this.facetType];
    return [
      {
        value: facet.validOperators[0],
        label: this.getOperatorDescription(facet.validOperators[0]),
      },
      {
        value: facet.validOperators[1],
        label: this.getOperatorDescription(facet.validOperators[1]),
      },
      {
        value: facet.validOperators[2],
        label: this.getOperatorDescription(facet.validOperators[2]),
      },
    ];
  }

  getValueSelectOptions() {
    const max = this.getAlertListLength() === 0 ? 1 : this.getAlertListLength();
    const options = [];

    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= max; i++) {
      options.push({
        label: `${i}`,
        value: i,
      });
    }

    return options;
  }

  // eslint-disable-next-line class-methods-use-this
  getTooltip(filtersByOperatorObj) {
    return `Alert Count ${
      filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
        ? `is EQUAL TO ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
          .map((filter) => filter.value1)
          .join(', ')
        }; `
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.GREATER_THAN]
        ? `is GREATER THAN ${filtersByOperatorObj[OperatorTypes.GREATER_THAN]
          .map((filter) => filter.value1)
          .join(', ')
        }; `
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.LESS_THAN]
        ? `is LESS THAN ${filtersByOperatorObj[OperatorTypes.LESS_THAN]
          .map((filter) => filter.value1)
          .join(', ')
        };`
        : ''
    }`;
  }
}
export default ChannelAlertCountFacet;
